import React from "react";
import { Navbar } from "../../components/user-components/NavigationBar/Navbar";
import { SkillsHead } from "../../components/user-components/Header/SkillsHead";
import { Skillme } from "../../components/user-components/Skillme/Skillme";

export const Skills = () => {
  return (
    <>
      <Navbar />
      <SkillsHead />
      <Skillme />
    </>
  );
};
